module.exports = "<div class=\"box-white pt-4 pb-4\">\r\n    <div class=\"container-main\">\r\n        <div class=\"container-fluid \">\r\n            <div class=\"container\">\r\n                <div class=\"row d-flex justify-content-center\">\r\n                    <div class=\"col-md-6 \">\r\n                        <app-fmsingup></app-fmsingup>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/frontend/signup/signup.component.html
// module id = ./src/app/frontend/signup/signup.component.html
// module chunks = frontend.module